import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

interface LoadMoreButtonProps {
  hasNextPage: boolean | undefined
  isFetchingNextPage: boolean
  onLoadMore: () => void
}

export function LoadMoreButton({ hasNextPage, isFetchingNextPage, onLoadMore }: LoadMoreButtonProps) {
  const { t } = useTranslation()

  if (!hasNextPage) return null

  return (
    <div className="flex justify-center py-4">
      <Button variant="ghost" onClick={onLoadMore} disabled={isFetchingNextPage}>
        {isFetchingNextPage ? (
          <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
        ) : (
          t('common.loadMore')
        )}
      </Button>
    </div>
  )
}
